import React from 'react';
import {RootState} from "../../../../../../../../reducers";
import {getSession} from "../../../../../../../services/Session/reducer";
import {connect} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {ReactComponent as LeftIco} from "../../../../../../../../images/icons/arrow-left.svg";
import ResponsiveComponent from "../../../../../../../components/Common/ResponsiveComponent";
import {FormatAddressString} from "go-core/components/Formatters/FormatAddress";

interface OwnProps {
    setShowAddressModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistoreMapPageNavbarLocation = ({session, setShowAddressModal}: Props) => {
    const {t} = useTranslation();

    return (
        <div className="d-flex">
            <ResponsiveComponent small={
                <Link className="btn btn-back d-flex align-items-center justify-content-center" to="/">
                    <LeftIco/>
                </Link>
            } large={<></>} breakpoint={769}/>
            <button className="d-flex flex-column justify-content-center location-container"
                    onClick={() => setShowAddressModal(true)}>
                <h5>
                    {t("modules.multistore.field.choose_place.title")}
                </h5>
                <small
                    className={`${session.full_address ? "" : "text-muted"} fw-normal`}>
                    {session.full_address ? FormatAddressString(session.address) : t("modules.multistore.field.enter_address.title")}
                </small>
            </button>
        </div>
    )
}
const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MultistoreMapPageNavbarLocation));